module.exports = __webpack_public_path__ + "static/media/exercicio3.0cbc8a70.png";